import React from "react";
import { useSettings } from "hooks/useStore";
import Link from "components/link";
import Image from "components/image";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";

const BlogItem = ({ blog }) => {
	const { toggleSearch } = useSettings(["toggleSearch"]);

	return (
		<Link
			key={blog._key}
			to={`/blogs/${blog.category.handle}/${blog.handle}`}
			onClick={toggleSearch}
			className="flex group md:h-fit gap-3 md:gap-5 md:w-[calc(50%-16px)] t-search-blog-click">
			<div className="w-28 aspect-square">
				<Image className="group-hover:scale-105 transition-all duration-300 h-full"
					image={blog.featuredImage} />
			</div>
			<div className="w-full md:w-4/5 flex justify-center gap-4">
				<div className="flex justify-center items-between flex-col">
					<p className="line-clamp-1 font-semibold text-sm md:text-xl">{blog.title}</p>
					<p className="line-clamp-2 md:line-clamp-3 text-xs md:text-base text-secondary">
						{blog.excerpt}
					</p>
				</div>
				<div className="w-fit py-1">
					<Arrow className="group-hover:fill-beige group-hover:pl-1 transition-all duration-300" />
				</div>
			</div>
		</Link>
	);
};

export default BlogItem;
